import safeToLowerCase from '../../utils/safeToLowerCase';

export default (savedPudoaddresses, blockedWordsForPudoSavedAddressesForLocales) => {
  let filteredSavedAddresses = savedPudoaddresses;
  blockedWordsForPudoSavedAddressesForLocales.forEach((blockedWordsForPudoSavedAddressesForLocale) => {
    const {blockedWords, countryCode} = blockedWordsForPudoSavedAddressesForLocale;
    if (countryCode && blockedWords && blockedWords.length) {
      filteredSavedAddresses = filteredSavedAddresses.filter((pudoSavedAddress) => {
        if (pudoSavedAddress.countryCode === countryCode) {
          const pudoAddressLines = Object.values(pudoSavedAddress) || [];
          
          return !pudoAddressLines
            .some(addressLine => blockedWords
              .some(bannedWord => safeToLowerCase(addressLine, true)
                ?.includes(safeToLowerCase(bannedWord, true))));
        }
        return true;
      });
    }
  });
  
  return filteredSavedAddresses;
};
